import styled, { css } from "styled-components";

export const CSS = {
   BUSINESS: styled.div`

   `,
   NAV: styled.nav`
      display: flex; align-items: center; justify-content: flex-end;
      height: 34px;
      background-color: rgb(69 97 251);
      ${props => !props.Media && css`
         max-width: 1004px; height: 80px;
         margin: auto;
      `}
      a {
         padding: 0 10px;
         font-size: 12px; color: rgb(255 255 255);
         cursor: pointer;
         ${props => !props.Media && css`
            font-weight: 500; font-size: 18px;
            padding: 0 30px;
         `}
         &:nth-child(1) {
            border-right: 1px solid #ffffff;
         }
         &:nth-child(2) {
            border-right: 1px solid #ffffff;
         }
      }
   `,
   SEC: styled.section`
      
   `,
   BOX: styled.div`
      ${props => props.Head && css`
         display: flex; flex-direction: column;
         align-items: center;
         padding: 5rem 0;
         h1 {
            font-size: 17px; color: rgb(28 31 95);
            ${props => !props.Media && css`
               font-weight: 500; font-size: 34px;
               letter-spacing: -0.94px;
            `}
         }
         h2 {
            font-family: 'Poppins', sans-serif; font-size: 36px; color: rgb(28 31 95);
            ${props => !props.Media && css`
               font-weight: 800; font-size: 72px;
               letter-spacing: -2px;
            `}
         }
         p {
            color: rgb(28 31 95);
            text-align: center; white-space: pre-wrap;
            ${props => !props.Media && css`
               font-weight: 400; font-size: 20px;
            `}
         }
         img {
            width: 320px;
            ${props => !props.Media && css`
               width: 895px;
            `}
         }
      `}
      ${props => props.Area && css`
         width: 100%;
         padding: 50px 20px;
         ${props => !props.Media && css`
            padding: 100px 20px;
         `}
         &>ul {
            min-width: 300px; max-width: 1004px;
            margin: auto;
            &>li {
               display: flex; flex-direction: column;
               align-items: flex-end; justify-content: flex-end;
               width: 300px; height: 120px;
               padding: 1rem; margin: auto;
               background-repeat: no-repeat;
               background-size: cover;
               ${props => !props.Media && css`
                  width: 100%; height: 380px;
                  padding: 45px 65px;
               `}
               &>span {
                  font-size: 12px; color: rgb(255 255 255);
                  ${props => !props.Media && css`
                     font-size: 29px;
                  `}
               }
            }
         }
      `}
      ${props => props.DBH && css`
         width: 100%;
         padding: 10px 20px;
         &>[types='wrap'] {
            width: 300px;
            margin: auto;
            ${props => !props.Media && css`
               width: 1004px;
               padding: 50px;
            `}
         }
         h1 {
            font-size: 17px; color: rgb(28 31 95);
            padding: 2.5px 0px;
            ${props => !props.Media && css`
               font-weight: 500; font-size: 34px;
               letter-spacing: -0.94px;
            `}
         }
         h2 {
            font-family: 'Poppins', sans-serif; font-size: 36px; color: rgb(28 31 95);
            padding: 2.5px 0px;
            ${props => !props.Media && css`
               font-weight: 800; font-size: 72px;
               letter-spacing: -2px;
            `}
         }
         p {
            position: relative;
            color: rgb(28 31 95);
            text-align: left; white-space: pre-wrap;
            padding: 5px 0px;
            ${props => !props.Media && css`
               font-weight: 400; font-size: 20px;
            `}
            img {
               position: absolute; right: 0px; top: 30px;
               width: 170px;
               ${props => !props.Media && css`
                  top: 70px;
                  width: 600px;
               `}
            }
         }
         a {
            display: block;
            width: 100px;
            text-align: center;
            font-family: 'Poppins', sans-serif; font-size: 13px; font-weight: 700;
            color: rgb(255 255 255); border-radius: 8px;
            padding: 5px 10px; margin: 10px 0px 50px;
            background-color: rgb(255 72 118);
            ${props => !props.Media && css`
               width: 190px;
               padding: 20px 0;
               font-size: 20px;
               margin: 30px 0 300px;
            `}
         }
      `}
      ${props => props.DV && css`
         background-color: rgb(137 239 215);
         &>[types='wrap'] {
            min-width: 300px; max-width: 1024px;
            padding: 10px;
            margin: auto;
            ${props => !props.Media && css`
               max-width: 1024px;
               padding: 0px 20px 50px;
            `}
         }
         [types="h"] {
            display: flex; flex-direction: column;
            align-items: center;
            width: 100%;
            padding: 20px 0;
            ${props => !props.Media && css`
               padding: 80px 0px 20px;
            `}
            h1 {
               width: 120px;
               font-size: 13px; color: rgb(255 255 255);
               padding: 5px 0px; text-align: center;
               border-radius: 20px;
               background-color: rgb(29 12 109);
               ${props => !props.Media && css`
                  width: 200px;
                  font-size: 22px;
                  margin: 15px 0 10px;
               `}
            }
            h2 {
               font-size: 25px; color: rgb(29 12 109);
               ${props => !props.Media && css`
                  font-size: 40px;
               `}
            }
            p {
               color: rgb(29 24 101);
               text-align: center;
               ${props => !props.Media && css`
                  font-size: 16px;
               `}
            }
         }
         [types="voucher"] {
            display: flex; justify-content: space-around;
            min-width: 300px; max-width: 300px;
            margin: auto;
            ${props => !props.Media && css`
               max-width: 1024px;
               word-break: keep-all;
            `}
            &>div {
               width: 140px;
               border-radius: 8px;
               padding: 10px;
               background-image: linear-gradient(to bottom, rgba(28, 33, 93, 0.6), rgba(28, 33, 93, 0.6)), linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(10, 10, 31, 0.7));
               ${props => !props.Media && css`
                  display: flex; flex-direction: column;
                  justify-content: space-between;
                  width: 480px; height: 420px;
                  padding: 50px;
               `}
               &>svg {
                  width: 40px; height: 40px;
                  ${props => !props.Media && css`
                     width: 80px; height: 90px;
                  `}
               }
               &>div {
                  padding-top: 10px;
                  color: rgb(255 255 255);
                  &>h1 {
                     font-size: 20px;
                     padding: 5px 0px;
                     ${props => !props.Media && css`
                        font-size: 32px;
                     `}
                  }
                  &>p {
                     font-size: 10px;
                     ${props => !props.Media && css`
                        font-size: 18px;
                        padding: 1rem 0;
                     `}
                  }
               }
            }
         }
         [types='ads'] {
            position: relative;
            display: flex; justify-content: center;
            min-width: 300px; max-height: 1024px;
            border-radius: 8px;
            margin: 20px 0px;
            ${props => !props.Media && css`
               display: block; justify-content: unset;
               padding: 30px;
               background-color: rgb(255 255 255);
            `}
            h1 {
               display: none;
               ${props => !props.Media && css`
                  display: flex;
                  font-size: 32px; color: rgb(29 6 112);
                  letter-spacing: -1px;
               `}
            }
            p {
               display: none;
               ${props => !props.Media && css`
                  display: flex;
                  font-size: 22px; color: rgb(29 0 120);
                  letter-spacing: -1px;
               `}
            }
            a {
               display: inline-block;
               color: rgb(255 255 255); font-size: 15px; font-weight: 700;
               padding: 10px 20px; margin: auto;
               border-radius: 8px;
               background-color: rgb(37 99 246);
               ${props => !props.Media && css`
                  font-size: 22px;
                  padding: 15px 30px;
                  margin: 30px 0px 0px;
               `}
            }
            img {
               display: none;
               ${props => !props.Media && css`
                  display: block;
                  position: absolute; right: 0; bottom: 50%;
                  transform: translateY(50%);
               `}
            }
         }
      `}
      ${props => props.AI && css`
         background-color: rgb(245 179 165);
         padding: 50px 20px;
         ${!props.Media && css`
            padding: 80px;
         `}
         [types='wrap'] {
            display: flex; flex-direction: column;
            align-items: center;
            &>h1 {
               font-size: 20px;
               color: rgb(29 0 114);
               ${!props.Media && css`
                  font-size: 40px;
               `}
               div {
                  display: flex; align-items: center; justify-content: center;
                  span {
                     font-family: 'Poppins', sans-serif; font-weight: 500;
                     font-size: 13px;
                     padding: 0px 10px;
                     color: rgb(255 255 255);
                     background-color: rgb(29 0 114);
                     ${!props.Media && css`
                        font-size: 24px;
                        padding: 0px 15px;
                     `}
                  }
               }
            }

            [types="1"] {
               div {
                  display: flex; align-items: center; justify-content: center;
                  padding: 10px 0px 0px;
                  ${!props.Media && css`
                     padding: 20px 0px 5px;
                  `}
                  img {
                     width: 40px;
                     ${!props.Media && css`
                        width: 80px;
                     `}
                  }
               }
               p {
                  display: flex; align-items: center; justify-content: center;
                  font-size: 12px;
                  color: rgb(29 24 101);
                  padding: 5px 0px;
                  ${!props.Media && css`
                     font-size: 20px;
                     padding: 15px 0px;
                  `}
                  span {
                     font-weight: 500;
                     font-size: 20px; 
                     letter-spacing: -0.75px;
                     color: rgb(253 253 254);
                     ${!props.Media && css`
                        font-size: 36px;
                     `}
                  }
               }
            }
            [types="2"] {
               padding: 10px 0px;
               ${!props.Media && css`
                  padding: 20px 0px;
               `}
               a {
                  font-family: 'Poppins', sans-serif;
                  font-weight: 500;
                  font-size: 15px;
                  padding: 10px 20px;
                  color: rgb(255 255 255);
                  border-radius: 8px;
                  background-color: rgb(255 72 118);
                  ${!props.Media && css`
                     font-size: 20px;
                     padding: 15px 40px;
                  `}
               }
            }
            [types="3"] {
               display: flex; flex-wrap: wrap;
               width: 300px;
               padding: 10px 0px 20px 0px;
               ${!props.Media && css`
                  width: 1004px;
                  padding: 15px 0px 40px 0px;
               `}
               img {
                  width: 280px;
                  margin: 5px auto;
                  ${!props.Media && css`
                     width: 480px;
                     margin: 10px auto;
                  `}
               }
            }
            [types="4"] {
               div {
                  display: flex; justify-content: center; align-items: center;
                  padding: 0px 0px 10px;
                  ${!props.Media && css`
                     padding: 0px 0px 30px;
                  `}
                  span {
                     font-weight: 500;
                     font-size: 20px;
                     color: rgb(253 253 254);
                     ${!props.Media && css`
                        font-size: 36px;
                     `}
                  }
               }
               img {
                  width: 300px;
                  background-color: rgb(255 255 255);
                  ${!props.Media && css`
                     width: 1004px;
                  `}
               }
            }
            [types="5"] {
               padding: 30px 0px 0px;
               ${!props.Media && css`
                  padding: 50px 0px 0px;
               `}
               ul {
                  display: flex; justify-content: space-around;
                  li {
                     padding: 10px 0px;
                     font-weight: 500;
                     color: rgb(255 255 255);
                     cursor: pointer;
                     ${!props.Media && css`
                        padding: 20px 0px;
                        font-size: 20px; font-weight: 500;
                     `}
                  }
               }
               div {
                  width: 300px;
                  ${!props.Media && css`
                     width: 1004px;
                  `}
                  img {
                     width: 100%;
                  }
               }
            }
         }
      `}
      ${props => props.Sol && css`
         padding: 40px 20px;
         background-color: rgb(37 99 246);
         ${!props.Media && css`
            padding: 80px;
         `}
         [types='wrap'] {
            display: flex; flex-direction: column;
            align-items: center;
            &>h1 {
               font-size: 20px;
               color: rgb(255 255 255);
               ${!props.Media && css`
                  font-size: 40px;
               `}
               div {
                  display: flex; align-items: center; justify-content: center;
                  span {
                     font-family: 'Poppins', sans-serif; font-weight: 500;
                     font-size: 13px;
                     padding: 0px 10px;
                     color: rgb(29 0 114);
                     background-color: rgb(255 255 255);
                     ${!props.Media && css`
                        font-size: 24px;
                        padding: 0px 15px;
                     `}
                  }
               }
            }
            [types="2"] {
               padding: 10px 0px;
               ${!props.Media && css`
                  padding: 20px 0px;
               `}
               a {
                  font-family: 'Poppins', sans-serif;
                  font-weight: 500;
                  font-size: 15px;
                  padding: 10px 20px;
                  color: rgb(255 255 255);
                  border-radius: 8px;
                  background-color: rgb(28 33 93);
                  ${!props.Media && css`
                     font-size: 20px;
                     padding: 15px 40px;
                  `}
               }
            }
         }
      `}
      ${props => props.Haccp && css`
         [types="wrap"] {
            min-width: 300px; max-width: 1004px;
            margin: auto;
            ${props => !props.Media && css`

            `}
            [types="intro"] {
               padding: 20px;
               ${props => !props.Media && css`
                  padding: 50px;
               `}
               h1 {
                  font-size: 17px; font-weight: 700;
                  letter-spacing: -0.94px;
                  color: rgb(28 31 95);
                  ${props => !props.Media && css`
                     font-size: 34px;
                  `}
               }
               h2 {
                  font-family: 'Poppins', sans-serif;
                  font-size: 36px; letter-spacing: -1px;
                  color: rgb(28 31 95);
                  ${props => !props.Media && css`
                     font-size: 72px;
                  `}
               }
               p {
                  color: rgb(29 24 101);
                  ${props => !props.Media && css`
                     font-size: 20px;
                  `}
               }
               img {
                  width: 100%;
                  padding: 30px 0 10px;
               }
            }
         }
      `}
      ${props => props.HaccpA && css`
         border-top: 1px solid rgb(151 151 151);
         border-bottom: 1px solid rgb(151 151 151);
         [types="wrap"] {
            min-width: 300px; max-width: 1004px;
            margin: auto;
            ${props => !props.Media && css`
               
            `}
            [types="h"] {
               padding: 20px;
               h1 {
                  font-size: 18px;
                  color: rgb(95 88 206);
                  text-align: center;
                  ${props => !props.Media && css`
                     font-size: 36px; letter-spacing: -0.75px;
                     padding: 30px 0px;
                  `}
               }
               p {
                  padding: 10px 0px;
                  font-size: 12px; font-weight: 300;
                  text-align: center; white-space: pre-wrap;
                  ${props => !props.Media && css`
                     font-size: 24px; letter-spacing: -0.5px;
                  `}
               }
            }
            [types="b"] {
               padding: 0px 0px 20px;
               ${!props.Media && css`
                  padding: 0px 0px 50px;
               `}
               &>div {
                  display: flex; align-items: center;
                  width: 300px; 
                  margin: auto; padding: 0px 0px 20px;
                  ${!props.Media && css`
                     justify-content: space-between;
                     width: 800px;
                  `}
                  &>img {
                     width: 100px;
                     margin: 10px;
                     ${!props.Media && css`
                        width: 300px;
                     `}
                     &[name="0"] {
                        transform: scale(0.6);
                     }
                  }
                  &>div {
                     ${!props.Media && css`
                        width: 350px;
                     `}
                     h1 {
                        white-space: pre-wrap;
                        ${!props.Media && css`
                           font-size: 28px;
                           word-break: keep-all;
                        `}
                     }
                     p {
                        white-space: pre-wrap;
                        ${!props.Media && css`
                           font-size: 22px;
                           word-break: keep-all;
                        `}
                     }
                  }
               }
            }
         }
      `}
      ${props => props.HaccpB && css`
         [types="wrap"] {
            min-width: 300px; max-width: 1004px;
            margin: auto;
            ${props => !props.Media && css`
               padding: 50px 0px;
            `}
            [types="h"] {
               padding: 20px;
               h1 {
                  font-size: 18px;
                  color: rgb(70 107 250);
                  text-align: center;
                  ${props => !props.Media && css`
                     font-size: 36px; letter-spacing: -0.75px;
                     padding: 30px 0px;
                  `}
               }
               p {
                  padding: 10px 0px;
                  font-size: 10px; font-weight: 300;
                  text-align: center;
                  color: rgb(29 24 101);
                  ${props => !props.Media && css`
                     font-size: 20px; letter-spacing: -0.5px;
                     white-space: pre-wrap;
                  `}
               }
            }
            [types="b"] {
               display: flex; justify-content: center;
               &>div {
                  display: flex; flex-direction: column;
                  justify-content: space-between;
                  width: 145px;
                  padding: 10px; margin: 5px;
                  border-radius: 8px; border: 1px solid rgb(29 17 106);
                  ${props => !props.Media && css`
                     width: 490px;
                     padding: 30px;
                  `}
                  p {
                     font-size: 12px; color: rgb(29 24 101);
                     ${props => !props.Media && css`
                        font-size: 24px;
                     `}
                  }
                  button {
                     width: 70px;
                     color: rgb(29 27 99);
                     border-radius: 2px; border: 1px solid rgb(29 17 106 / 0.05);
                     padding: 5px; margin-top: 20px;
                     background-color: rgb(30 30 97 / 0.05);
                     ${props => !props.Media && css`
                        width: 180px;
                        font-size: 20px;
                        padding: 15px 0px;
                     `}
                  }
               }
            }
            [types="b1"] {
               display: flex; flex-direction: column;
               padding: 20px 10px 0px;
               ${!props.Media && css`
                  padding: 40px 0px 20px;
               `}
               &>h1 {
                  font-size: 18px; letter-spacing: -0.67px;
                  text-align: center;
                  color: rgb(83 83 85);
                  padding: 10px 0px 20px;
                  ${!props.Media && css`
                     font-size: 32px;
                     padding: 20px 0px 40px;
                  `}
               }
               &>div {
                  width: 100%;
                  border-top: 5px solid rgb(82 77 248);
                  text-align: center;
                  ${!props.Media && css`
                     padding: 40px 0px;
                  `}
                  &>div {
                     display: inline-block;
                     width: 150px; height: 150px;
                     padding: 10px;
                     ${!props.Media && css`
                        width: 250px; height: 250px;
                        padding: 20px;
                     `}
                     &>div {
                        display: flex; align-items: center; justify-content: center;
                        width: 100%; height: 100%;
                        border-radius: 50%;
                        background-color: rgb(245 241 255);
                        &>div {
                           width: 90px; height: 90px;
                           text-align: left;
                           ${!props.Media && css`
                              width: 130px; height: 130px;
                           `}
                           h1 {
                              font-size: 17px;
                              padding: 5px 0px;
                              ${!props.Media && css`
                                 font-size: 30px;
                              `}
                           }
                           div {
                              font-size: 15px;
                              color: rgb(113 113 113);
                              padding: 5px 0px;
                              border-top: 2px solid rgb(151 151 151);
                              white-space: pre-wrap;
                              ${!props.Media && css`
                                 font-size: 22px;
                                 border-top: 4px solid rgb(151 151 151);
                              `}
                           }
                        }
                     }
                  }
               }
            }
            [types="b2"] {
               display: flex; flex-direction: column;
               padding: 20px 10px 0px;
               ${!props.Media && css`
                  padding: 40px 0px 20px;
               `}
               &>h1 {
                  font-size: 18px; letter-spacing: -0.67px;
                  text-align: center;
                  color: rgb(83 83 85);
                  padding: 10px 0px 20px;
                  ${!props.Media && css`
                     font-size: 32px;
                     padding: 20px 0px 40px;
                  `}
               }
               &>div {
                  width: 100%;
                  border-top: 5px solid rgb(1 200 126);
                  padding: 20px 0px;
                  img {
                     width: 100%;
                  }
               }
            }
            [types="b3"] {
               display: flex; justify-content: center;
               a {
                  color: rgb(255 255 255);
                  padding: 7px 10px; margin: 30px auto;
                  border-radius: 4px; 
                  background-color: rgb(1 200 126);
                  ${props => !props.Media && css`
                     font-size: 22px; font-weight: 800;
                     padding: 20px 40px;
                  `}
               }
            }
         }
      `}
   `,
}